// extracted by mini-css-extract-plugin
var _1 = "FloatingArrow-module__arrow--i_jvj";
var _2 = "8px";
export { _1 as "arrow", _2 as "arrowSize" }
